import { render, staticRenderFns } from "./SiAccounts.vue?vue&type=template&id=31097a24&scoped=true&"
import script from "./SiAccounts.vue?vue&type=script&lang=js&"
export * from "./SiAccounts.vue?vue&type=script&lang=js&"
import style0 from "./SiAccounts.vue?vue&type=style&index=0&id=31097a24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31097a24",
  null
  
)

export default component.exports